"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiMenuOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        list: {
            padding: spacing(1, 1),
        },
    });
};
//# sourceMappingURL=MuiMenu.js.map